import { HubJsonRpcRequest } from '../../../api/HubJsonRpcRequest';
import { ResetEmailPasswordResponse } from '../../../api/hub-responses/reset-email-password-response';
import { HubApiMethods } from '../../../constants/HubApiMethods';

export type ResetEmailPasswordRequest = {
    email: string,
    locale: string
}

export function resetEmailPassword(data: ResetEmailPasswordRequest): Promise<ResetEmailPasswordResponse> {
    return HubJsonRpcRequest.makeRequest<ResetEmailPasswordResponse, ResetEmailPasswordRequest>(HubApiMethods.RESET_EMAIL_PASSWORD, data);
}
